<template>
  <div class="min-h-screen">
    <div class="pagination-bg pagination-bg-sm pagination-bg-lg pagination-bg-2xl bg-center">
      <div class="max-w-7xl mx-auto pt-16 sm:pt-20">
        <div class="flex justify-center">
          <img src="@/assets/news.svg" alt="最新消息" class="sm:w-16 sm:h-16"/>
        </div>
        <h1 class="text-3xl sm:text-4xl font-black mt-5">最新消息</h1>
      </div>
    </div>
    <div class="max-w-7xl mx-auto mt-10 px-10">
      <div class="flex space-x-5 justify-start mb-16">
        <router-link to="/">
          <div class="font-bold text-lg">首頁</div>
        </router-link>
        <p class="text-lg">></p>
        <p class="text-lg text-color-blue font-bold text-left">最新消息</p>
      </div>
      <!-- 最新消息Start -->
      <div v-for='aNews in news' :key="aNews.id">
        <div class="bg-gray-200 rounded-full h-16 mt-6 py-2 px-8 flex items-center justify-center sm:justify-start text-lg">
          <div class="truncate">
            <span class="date flex-none">{{ aNews.date }}&emsp;</span>
            <br class="sm:hidden">
            <router-link :to="`/news/${aNews.id}`" >
              {{ aNews.title }}
            </router-link>
          </div>
        </div>
      </div>
      <!-- 最新消息End -->
    </div>
    <!-- 分頁Strat -->
    <div class="mt-14 mb-20">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="perPage"
        :total="totalCount"
        background
        layout="prev, pager, next"
      />
    </div>
    <!-- 分頁End -->
  </div>
  <div class="footer-bg"></div>
</template>

<script>
import * as newsApi from '@/api/news'

export default {
  title: '最新消息-TAIE',
  data() {
    return {
      // 分頁
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      totalCount: 10,

      pagination: {},
      news: []
    }
  },

  mounted() {
    this.getNewsList()
  },
  methods: {
    getNewsList () {
      const searchFields = {}
      searchFields.page = this.currentPage ? this.currentPage : 1
      newsApi.getNews(searchFields.page).then(
        (response) => {
          this.news = response.data;
          this.totalPages = response.meta.pagination.total_pages
          this.currentPage = response.meta.pagination.current_page
          this.perPage = response.meta.pagination.per_page
          this.totalCount = response.meta.pagination.total
        },
        (error) => {
          this.content =
            (error.response && error.response.data && error.response.data.message) ||
              error.message || error.toString()
        }
      )
    },
    handleCurrentChange (page) {
      this.currentPage = page
      this.getNewsList()
    }
  }
}
</script>

<style>
@media (min-width: 1536px) {
  .pagination-bg-2xl {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1536.jpg");
  }
}

@media (min-width: 1024px) and (max-width: 1535.98px) {
  .pagination-bg-lg {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1024.jpg");
  }
}

@media (min-width: 640px) and (max-width: 1023.98px) {
  .pagination-bg-sm {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over640.jpg");
  }
}

@media (max-width: 639.98px) {
  .pagination-bg {
    width: 100%;
    height: 250px;
    background-image: url("../../assets/pagination-bg-under640.jpg");
  }
}

a:hover {
color:#64859D;
}

.text-color-blue {
  color: #64859D;
}

.date {
  color: #405d73;
}

.btn-prev {
  border-radius: 50px !important;
  background-color: #ffffff !important;
  border-style: solid !important;
  border-width: 1px !important;
  padding-left: 8px !important;
}

.btn-next {
  border-radius: 50px !important;
  background-color: #ffffff !important;
  border-style: solid !important;
  border-width: 1px !important;
  padding-left: 8px !important;
}

li.active.number {
  border-radius: 50px !important;
  background-color: #C9A798 !important;
}

li.number {
  border-radius: 50px !important;
}

.el-icon {
  border-radius: 50px !important;
}

.footer-bg {
  width: 100%;
  height: 10px;
  background-image: url("../../assets/footer-bg.svg");
}
</style>
